<template>
  <div ref="map" style="width: 100%; height: 420px; border-radius: 10px;"></div>
</template>

<script>
export default {

  name: "ShippingRoute",

  props: {

    apiKey: {

      type: String,

      required: true

    },

    points: {

      type: Array,

      required: true

    },

    vesselPoint: {

      type: Object,

      default: null

    },

    mapOptions: {

      type: Object,

      default: () => ({

        zoom: 8,

        center: { lat: 9.9333, lng: -84.0833 },

        mapTypeControl: false,

        streetViewControl: false

      })

    }

  },

  data() {

    return {

      map: null,

      polyline: null,

      startMarker: null,

      endMarker: null,

      vesselMarker: null

    };

  },

  async mounted() {

    await this.ensureGoogleMapsLoaded();

    this.initMap();

    this.drawRoute(this.points);

    this.drawVesselMarker(this.vesselPoint);

  },

  watch: {

    points: {

      deep: true,

      handler(newPoints) {

        this.drawRoute(newPoints);

      }

    },

    vesselPoint: {

      deep: true,

      handler(newPoint) {

        this.drawVesselMarker(newPoint);

      }

    }

  },

  methods: {

    ensureGoogleMapsLoaded() {

      return new Promise((resolve, reject) => {

        if (window.google && window.google.maps) {

          resolve();


          return;

        }


        const existing = document.querySelector("script[data-google-maps=\"1\"]");

        if (existing) {

          existing.addEventListener("load", () => resolve());


          existing.addEventListener("error", (e) => reject(e));


          return;

        }


        const script = document.createElement("script");

        script.setAttribute("data-google-maps", "1");

        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(this.apiKey)}&libraries=geometry`;

        script.async = true;

        script.defer = true;

        script.onload = () => resolve();

        script.onerror = (e) => reject(e);

        document.head.appendChild(script);

      });

    },

    initMap() {

      this.map = new window.google.maps.Map(this.$refs.map, {

        ...this.mapOptions,

        styles: [
          {
            elementType: "geometry",
            stylers: [{ saturation: -50 }]
          }
        ]

      });

    },

    drawRoute(points) {

      if (!this.map) {

        return;

      }

      const safePoints = Array.isArray(points) ? points.filter(p => this.isValidLatLng(p)) : [];

      if (safePoints.length < 2) {

        this.clearRoute();

        if (safePoints.length === 1) {

          this.map.setCenter(safePoints[0]);

          this.map.setZoom(13);

        }

        return;

      }

      this.clearRoute();

      this.polyline = new window.google.maps.Polyline({
        path: safePoints,
        geodesic: true,
        strokeOpacity: 0,
        strokeWeight: 4,
        icons: [
          {
            icon: {
              path: 'M 0,-1 0,1',
              strokeOpacity: 1,
              strokeColor: '#2183c3',
              strokeWeight: 2
            },
            offset: '0',
            repeat: '15px'
          }
        ]
      });

      this.polyline.setMap(this.map);

      //////////////////////////////////////////////////////////////////////////

      const startSvg = {
        path: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z",
        fillColor: "#087fd3",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        scale: 1.4,
        anchor: new window.google.maps.Point(12, 20)
      };

      this.startMarker = new window.google.maps.Marker({
        position: safePoints[0],
        map: this.map,
        title: "Inicio",
        icon: startSvg,
      });

      //////////////////////////////////////////////////////////////////////////

      const endSvg = {
        path: "M22,21V7L12,3L2,7v14h5v-9h10v9H22z M11,19H9v2h2V19z M13,16h-2v2h2V16z M15,19h-2v2h2V19z",
        fillColor: "#087fd3",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        scale: 1.4,
        anchor: new window.google.maps.Point(12, 20)
      };

      this.endMarker = new window.google.maps.Marker({
        position: safePoints[safePoints.length - 1],
        map: this.map,
        title: "Fin",
        icon: endSvg,
      });

      const bounds = new window.google.maps.LatLngBounds();

      safePoints.forEach(p => bounds.extend(p));

      this.map.fitBounds(bounds);

    },

    drawVesselMarker(point) {

      if (!this.map) return;

      if (!this.isValidLatLng(point)) {

        if (this.vesselMarker) {

          this.vesselMarker.setMap(null);

          this.vesselMarker = null;

        }

        return;

      }

      if (!this.vesselMarker) {

        const shipSvg = {
          path: "M20,21c-1.39,0-2.78-0.47-4-1.32c-2.44,1.71-5.56,1.71-8,0C6.78,20.53,5.39,21,4,21H2v2h2c1.38,0,2.74-0.35,4-0.99 c2.52,1.29,5.48,1.29,8,0c1.26,0.65,2.62,0.99,4,0.99h2v-2H20z M3.95,19H4c1.6,0,3.02-0.88,4-2c0.98,1.12,2.4,2,4,2s3.02-0.88,4-2 c0.98,1.12,2.4,2,4,2h0.05l1.9-6.68c0.11-0.37,0.04-1.06-0.66-1.28L20,10.62V6c0-1.1-0.9-2-2-2h-3V1H9v3H6C4.9,4,4,4.9,4,6v4.62 l-1.29,0.42c-0.63,0.19-0.81,0.84-0.66,1.28L3.95,19z M6,6h12v3.97L12,8L6,9.97V6z",
          fillColor: "#dc3545",
          fillOpacity: 1,
          strokeColor: "#ffffff",
          strokeWeight: 2,
          scale: 1.4,
          anchor: new window.google.maps.Point(12, 20)
        };

        this.vesselMarker = new window.google.maps.Marker({
          map: this.map,
          position: point,
          zIndex: 10000,
          icon: shipSvg,
          title: "Posición actual"

        });

      } else {

        this.vesselMarker.setCenter(point);

      }

    },

    clearRoute() {

      if (this.polyline) {

        this.polyline.setMap(null);

        this.polyline = null;

      }

      if (this.startMarker) {

        this.startMarker.setMap(null);

        this.startMarker = null;

      }

      if (this.endMarker) {

        this.endMarker.setMap(null);

        this.endMarker = null;

      }

      if (this.vesselMarker) {

        this.vesselMarker.setMap(null);

        this.vesselMarker = null;

      }

    },

    isValidLatLng(p) {

      if (!p || typeof p !== "object") {

        return false;

      }

      const lat = Number(p.lat);

      const lng = Number(p.lng);

      return Number.isFinite(lat) && Number.isFinite(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;

    }

  }

};
</script>
